import gql from 'graphql-tag';
import { EVENT_ACTIVITY_NOTE_FRAGMENT } from './fragments/eventActivityNote.fragment';

export const CALENDAR_EVENT_NOTES = gql`
  query CalendarEventNotes($input: CalendarEventNotesInput!) {
    dealActivity {
      result: calendarEventNotes(input: $input) {
        error
        success
        list {
          __typename
          ...DealEventActivityNoteFields
        }
      }
    }
  }
  ${EVENT_ACTIVITY_NOTE_FRAGMENT}
`;
